import { useEffect, useState } from "react";
import styles from "./Modal.module.css";

function ModalWrapper({ children, name, title, onClose, isVisible, level = 1, fit }) {
  const [isCurrentModal, setIsCurrentModal] = useState(false);

  useEffect(() => {
    const handleEscKeyPress = (e) => {
      if (e.key === "Escape") handleClose();
    };
    if (isVisible) document.addEventListener("keydown", handleEscKeyPress);

    return () => document.removeEventListener("keydown", handleEscKeyPress);
  }, [isVisible]);

  useEffect(() => {
    const modalStack = JSON.parse(localStorage.getItem("modalStack")) || [];
    if (isVisible && !modalStack.includes(name)) {
      modalStack.push(name);
      localStorage.setItem("modalStack", JSON.stringify(modalStack));
      setIsCurrentModal(true);
      return;
    }
    const index = modalStack.indexOf(name);
    if (index === modalStack.length - 1) setIsCurrentModal(true);
  }, []);

  const handleClose = () => {
    const modalStack = JSON.parse(localStorage.getItem("modalStack")) || [];
    const index = modalStack.indexOf(name);
    if (index !== -1 && index === modalStack.length - 1) {
      modalStack.splice(index, 1);
      if (modalStack.length === 0) localStorage.removeItem("modalStack");
      else localStorage.setItem("modalStack", JSON.stringify(modalStack));
    }
    onClose();
  };

  return (
    <div className={`${styles.wrapper} ${styles[`level_${level}`]}`} onClick={handleClose}>
      <div className={`${styles.modal} ${fit && styles.fit}`} onClick={(e) => e.stopPropagation()}>
        {title && <div className={styles.title}>{title}</div>}
        {children}
      </div>
    </div>
  );
}

export default ModalWrapper;
